import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import classNames from 'classnames/bind';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import Button from 'yoda-core-components/lib/components/Button';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import RecommendationSwitch from 'yoda-site-components/lib/components/RecommendationSwitch';
import BVSummary from 'yoda-site-components/lib/components/BVSummary/BVSummary';
import ProductTitle from 'yoda-site-components/lib/components/ProductTitle/ProductTitle';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import withReducerSaga from 'yoda-site-components/lib/hoc/ReducerRegistry/withReducerSaga';
import CouponDetailsReducer from 'yoda-site-components/lib/reducers/CouponDetailsReducer';
import { selectPreferences } from 'yoda-site-components/lib/selectors/ContextSelector';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Metadata from '../../../../components/Metadata/Metadata';
import PDPBreadcrumbs from '../../../../components/PDPBreadcrumbs/PDPBreadcrumbs';
import ProductImage from '../../../../components/ProductImage/ProductImage';
import ProductInfoMobile from '../../../../components/ProductInfo/ProductInfoMobile';
import ProductInfoDesktop from '../../../../components/ProductInfo/ProductInfoDesktop';
import BundleAddToCart from '../../../../components/Bundle/BundleAddToCart/BundleAddToCart';
import BundleCollectionDetails from '../../../../components/Bundle/BundleChildLevel/BundleCollectionDetails';
import BundleChildTitle from '../../../../components/Bundle/BundleChildLevel/BundleChildTitle';
import productPricingSelector, {
    isSameProductsCoupons,
    isAllItemsHaveCoupons,
} from '../../../../selectors/Bundle/BundleProductPricingSelector';
import BundlePricingWrapper from '../../../../components/Bundle/BundlePricing/BundlePricingWrapper';
import Pricing from '../../../../components/Bundle/BundlePricing/BundlePricing';
import IrisS1ClientPromoBanner from '../../../../components/IrisS1PromoBanner/IrisS1ClientPromoBanner';
import SkinnyClientBanner from '../../../../components/SkinnyBanner/SkinnyClientBanner';
import {
    SKINNEY_BANNER_CATID_EXCLUSION_LIST,
    SKINNEY_BANNER_EMPTY_DIV_HEIGHT,
} from '../../../../components/SkinnyBanner/Config';
import {
    onPageReady,
    pageLoadReadyScuccess,
    pageLoadProductOOS,
} from '../../../../actions/AnalyticsAction';
import BundleProductInfoSelector from '../../../../selectors/Bundle/BundleProductInfoSelector';
import BundleInventorySaga from '../../../../sagas/BundleInventorySaga';
import BundleItemOfferingSaga from '../../../../sagas/BundleItemOfferingSaga';
import BundleItemOfferingReducer from '../../../../reducers/BundleItemOfferingReducer';
import BundleInventoryReducer from '../../../../reducers/BundleInventoryReducer';
import BundleNetPriceSaga from '../../../../sagas/BundleNetPriceSaga';
import BundleNetPriceReducer from '../../../../reducers/BundleNetPriceReducer';
import BundleQuantityReducer from '../../../../reducers/BundleQuantityReducer';
import BundleProtectionPlanReducer from '../../../../reducers/BundleProtectionPlanReducer';

import BundleQuantityModalReducer from '../../../../reducers/BundleQuantityModalReducer';
import {
    isPromotionalBundle,
    isFpacForBundle as isFpacForBundleSelector,
} from '../../../../selectors/Bundle/BundleCommonSelector';
import Canonicalize from '../../../../components/Canonicalize/Canonicalize';
import DescriptionAndShipping from '../../../../components/DescriptionAndShipping/DescriptionAndShipping';
import * as styles from '../PDP.css';
import BelowTheFold from '../../../../components/BelowTheFold/BelowTheFold';

const cx = classNames.bind(styles);

export class BundlePage extends Component {
    static propTypes = {
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        pricingDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        query: PropTypes.oneOfType([PropTypes.object]),
        location: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.oneOfType(PropTypes.object),
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        productInfoSelector: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        isPromotional: PropTypes.bool.isRequired,
        ppId: PropTypes.string,
        preferences: PropTypes.oneOfType([PropTypes.object]),
        isSameCoupons: PropTypes.bool,
        allItemsHaveCoupons: PropTypes.bool,
        isFpacForBundle: PropTypes.bool,
        isNative: PropTypes.bool,
    };

    static defaultProps = {
        productDetails: {},
        actions: {},
        pricing: {},
        location: {},
        settings: [],
        query: {},
        featureFlags: {},
        deviceType: {},
        pricingDetails: {},
        productInfoSelector: {},
        ppId: '',
        preferences: {},
        isCollection: false,
        isSameCoupons: false,
        allItemsHaveCoupons: false,
        isFpacForBundle: false,
        isNative: false,
    };

    shouldComponentUpdate(nextProps) {
        return !isEqual(this.props, nextProps);
    }

    componentDidUpdate(prevProps) {
        const { location, featureFlags } = this.props;
        const { enableDigitalDataInventory = true } = featureFlags;
        const query = makeQuery(location.search);
        const isCollectionsClicked = query && query.enrId ? 'yes' : null;
        if (
            !prevProps.analytics.pageReadyCmpleted &&
            !isEqual(prevProps.pricingDetails, this.props.pricingDetails)
        ) {
            this.props.actions.onPageReady({
                templateType: query.pTmplType,
                searchAvailable: query.Ntt,
                collectionView: isCollectionsClicked,
                isBundle: true,
            });
            this.props.actions.pageLoadReadyScuccess({ pageReadyCmpleted: true });
            enableDigitalDataInventory &&
                this.props.actions.pageLoadProductOOS({
                    templateType: query.pTmplType,
                    searchAvailable: query.Ntt,
                    collectionView: isCollectionsClicked,
                    isBundle: true,
                });
        }
    }

    moveToSelectOption = () => {
        const getBundleProductParentEle = document.querySelector(
            '[data-automation-id="bundleParent"]'
        );
        /* istanbul ignore next */
        if (getBundleProductParentEle) {
            getBundleProductParentEle.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    };

    renderTitleSection = () => {
        const { productDetails, featureFlags } = this.props;
        return (
            <div className={cx('col12', 'productTitleContainer')}>
                <ErrorBoundary>
                    <ProductTitle
                        className={`${cx('header-3')} ${dt([
                            'lg:!mb-2',
                            'smMd:mb-1',
                            'leading-7',
                        ])}`}
                        dataAutomationId="product-title"
                        title={productDetails.name}
                        primary
                        primaryProductDisplay
                    />
                </ErrorBoundary>
                <ErrorBoundary>
                    {get(featureFlags, 'bazaarVoice', true) && (
                        <div className={cx('col12', 'noPad')}>
                            <BVSummary
                                productDetails={productDetails}
                                primaryProductDisplay
                                isBundle
                            />
                        </div>
                    )}
                </ErrorBoundary>
            </div>
        );
    };

    render() {
        const {
            productDetails,
            preferences,
            pricingDetails,
            deviceType,
            ppId,
            query,
            productInfoSelector,
            isPromotional,
            featureFlags,
            isSameCoupons,
            allItemsHaveCoupons,
            isFpacForBundle,
        } = this.props;
        const isMobileView = deviceType.isMobile;
        const recSlots = preferences?.recommendations?.slots || [];
        // Render ONLY slots explicitly tagged for the main zone.
        // `recommendations.slots` is a merge of this page's slots AND shared/common
        // slots injected into every microsite; rendering anything untagged would leak
        // those common slots (e.g. oos/addtocart/rewards) into this zone. So we require
        // an explicit `zone === 'main'` and never fall back to "render all".
        const bundleRecSlots = recSlots.filter((s) => s.zone === 'main');
        const {
            enableBundleNetPrice = true,
            enableS1IrisPromoBanner = false,
            enableSSRS1IrisPromoBanner = false,
            enableSkinnyBanner = false,
        } = featureFlags;
        let pdpDivision = '';
        const breadcrumbs = get(productDetails, 'breadCrumbInfo.breadcrumbs', []);
        const rowClasses = [
            dt(['bg-white', 'm-0', 'pt-2', 'px-4', 'pb-0', 'smOnly:pt-0']),
            cx('row'),
        ].join(' ');
        const breadcrumbsRowStyle = dt(['smMd:!pt-0']);

        /* istanbul ignore next */
        if (breadcrumbs.length) {
            pdpDivision = get(breadcrumbs, '[1].breadCrumbLabel', '');
        }
        const { enableHttpsCanonical = true } = featureFlags;

        let renderS1Banner;
        if (enableS1IrisPromoBanner) {
            renderS1Banner = (
                <IrisS1ClientPromoBanner
                    productDetails={productDetails}
                    ppId={ppId}
                    tmplType=""
                    topPromotionalBanner
                />
            );
        }
        const {
            skinnyBannerConfig: {
                emptyDivHeight = SKINNEY_BANNER_EMPTY_DIV_HEIGHT,
                exclusionCatIds = SKINNEY_BANNER_CATID_EXCLUSION_LIST,
            } = {},
        } = preferences;
        const categoryId = productDetails?.category?.id;
        if (
            !enableS1IrisPromoBanner &&
            enableSkinnyBanner &&
            !exclusionCatIds?.includes(categoryId)
        ) {
            renderS1Banner = (
                <SkinnyClientBanner emptyDivHeight={emptyDivHeight} topPromotionalBanner />
            );
        }
        return (
            <>
                <ErrorBoundary>
                    {featureFlags.performURLProfanity ? (
                        <Canonicalize
                            productDetails={productDetails}
                            location={this.props.location}
                        />
                    ) : null}
                </ErrorBoundary>
                <ErrorBoundary>
                    <Metadata
                        productDetails={productDetails}
                        preferences={preferences}
                        location={this.props.location}
                        httpsCanonical={enableHttpsCanonical}
                    />
                </ErrorBoundary>
                <section className={`${dt(['px-6'])} ${cx('pdp-container')}`}>
                    <section className={cx(rowClasses, 'noPad')}>
                        <ErrorBoundary>{renderS1Banner}</ErrorBoundary>
                    </section>
                    <section
                        className={cx(rowClasses, breadcrumbsRowStyle, 'bundleRow', {
                            noPad: deviceType.isDesktop,
                        })}
                    >
                        <ErrorBoundary>
                            <PDPBreadcrumbs ppId={ppId} query={query} />
                        </ErrorBoundary>
                        {isMobileView ? this.renderTitleSection() : null}
                    </section>
                    <section className={cx(rowClasses, 'bundleContainerSpacing', 'bundleRow')}>
                        {!isMobileView && (
                            <div
                                className={`${cx('sm12', 'md6', 'lg6', 'xl7')} ${dt([
                                    'mdOnly:!pl-0',
                                    'mdOnly:!pr-2',
                                ])}`}
                            >
                                <ErrorBoundary>
                                    <ProductImage
                                        resizeOnScroll={false}
                                        productDetails={productDetails}
                                        dataAutomationId="product-image-block"
                                        isBundle
                                    />
                                </ErrorBoundary>
                            </div>
                        )}
                        <div
                            className={`${cx('sm12', 'md6', 'lg6', 'xl5')} ${dt([
                                'smOnly:!px-0',
                                'mdOnly:!pl-2',
                                'mdOnly:!pr-0',
                            ])}`}
                        >
                            {/* For breakpoints other than mobile  */}
                            {!isMobileView ? this.renderTitleSection() : null}
                            {/* eslint-disable react/no-danger */}
                            <ErrorBoundary>
                                <Pricing
                                    isBundlePage
                                    pricingDetails={pricingDetails}
                                    featureFlags={featureFlags}
                                    isSameCoupons={isSameCoupons}
                                    allItemsHaveCoupons={allItemsHaveCoupons}
                                    isFpacForBundle={isFpacForBundle}
                                    productType="bundle"
                                />
                            </ErrorBoundary>
                            {isMobileView && (
                                <div
                                    className={`${cx('sm12', 'md6', 'lg6', 'xl7')} ${dt([
                                        'smOnly:!px-0',
                                        'smOnly:!-mx-6',
                                        'smOnly:!w-[calc(100%+48px)]',
                                    ])}`}
                                >
                                    <ErrorBoundary>
                                        <ProductImage
                                            resizeOnScroll={false}
                                            productDetails={productDetails}
                                            dataAutomationId="product-image-block"
                                            isBundle
                                        />
                                    </ErrorBoundary>
                                </div>
                            )}
                            {/* <div className={cx('saveMoreMessage')}>{pricingDetails.promotionalMessage}</div> */}
                            {productDetails.description && productDetails.description !== '' ? (
                                <div
                                    data-automation-id="bundle-product-details"
                                    dangerouslySetInnerHTML={{ __html: productDetails.description }}
                                    className={cx('bundleProdDesc')}
                                />
                            ) : (
                                <ErrorBoundary>
                                    <BundleChildTitle productDetails={productDetails} />
                                </ErrorBoundary>
                            )}
                            {deviceType.isDesktop && (
                                <div
                                    className={cx(
                                        'selectOption',
                                        'sm6',
                                        'md6',
                                        'lg6',
                                        'xl6',
                                        'bundleSelectOption'
                                    )}
                                >
                                    <Button
                                        size="Lg"
                                        automationId="select-option-below"
                                        className={cx('selectOptionBtn')}
                                        onClick={this.moveToSelectOption}
                                    >
                                        <span className={cx('btnText')}>
                                            {isPromotional
                                                ? 'Select Option Below'
                                                : 'Shop the Collection'}
                                        </span>
                                    </Button>
                                </div>
                            )}
                        </div>
                    </section>

                    <ErrorBoundary>
                        <BundleCollectionDetails
                            productDetails={productDetails}
                            featureFlags={featureFlags}
                            isPromotionalBundle={isPromotional}
                        />
                    </ErrorBoundary>
                    {!deviceType.isDesktop && (
                        <section className={cx(rowClasses, 'bundlePricing')}>
                            <div className={cx('md6', 'lg6', 'xl7')} />
                            <div
                                className={`${cx(
                                    'sm12',
                                    'md6',
                                    'lg6',
                                    'xl5',
                                    'bundlePriceBlock'
                                )} ${dt(['smMd:!pt-6'])}`}
                            >
                                <ErrorBoundary>
                                    {enableBundleNetPrice ? (
                                        <BundlePricingWrapper />
                                    ) : (
                                        <Pricing
                                            productType="bundle"
                                            pricingDetails={pricingDetails}
                                            featureFlags={featureFlags}
                                            isSameCoupons={isSameCoupons}
                                            isFpacForBundle={isFpacForBundle}
                                            allItemsHaveCoupons={allItemsHaveCoupons}
                                            isBundlePage
                                            isAddtoCartPricing
                                        />
                                    )}
                                </ErrorBoundary>
                            </div>
                            <div className={cx('md6', 'lg6', 'xl7')} />
                            <div className={cx('sm12', 'md6', 'lg6', 'xl5', 'bundleAddtoCart')}>
                                <ErrorBoundary>
                                    <BundleAddToCart />
                                </ErrorBoundary>
                            </div>
                        </section>
                    )}

                    {deviceType.isDesktop && (
                        <section className={cx(rowClasses, 'bundlePricing')}>
                            <div className={cx('sm7', 'md7', 'lg7', 'xl7')} />
                            <div
                                className={`${cx(
                                    'sm5',
                                    'md5',
                                    'lg5',
                                    'xl5',
                                    'bundlePriceBlock'
                                )} ${dt(['pt-6'])}`}
                            >
                                <ErrorBoundary>
                                    {enableBundleNetPrice ? (
                                        <BundlePricingWrapper />
                                    ) : (
                                        <Pricing
                                            productType="bundle"
                                            pricingDetails={pricingDetails}
                                            featureFlags={featureFlags}
                                            isSameCoupons={isSameCoupons}
                                            isFpacForBundle={isFpacForBundle}
                                            allItemsHaveCoupons={allItemsHaveCoupons}
                                            isBundlePage
                                        />
                                    )}
                                </ErrorBoundary>
                            </div>
                            <div className={cx('sm7', 'md7', 'lg7', 'xl7')} />
                            <div className={cx('sm5', 'md5', 'lg5', 'xl5', 'bundleAddtoCart')}>
                                <ErrorBoundary>
                                    <BundleAddToCart />
                                </ErrorBoundary>
                            </div>
                        </section>
                    )}
                    <ErrorBoundary>
                        <div className={dt(['pb-10'])}>
                            <DescriptionAndShipping />
                        </div>
                    </ErrorBoundary>
                    {deviceType.isDesktop ? (
                        <section className={`${cx('section')} ${dt(['sm:!my-0'])}`}>
                            <div className={cx('small12', 'medium12', 'large12', 'extraLarge12')}>
                                <ErrorBoundary>
                                    <ProductInfoDesktop
                                        dataAutomationId="product-info"
                                        productDetails={productInfoSelector}
                                        type="BUNDLE"
                                    />
                                </ErrorBoundary>
                            </div>
                        </section>
                    ) : (
                        <section className={`${cx('section')} ${dt(['sm:!my-0'])}`}>
                            <div
                                className={cx(
                                    'small12',
                                    'medium12',
                                    'large12',
                                    'extraLarge12',
                                    rowClasses
                                )}
                            >
                                <ErrorBoundary>
                                    <ProductInfoMobile
                                        dataAutomationId="product-info"
                                        productDetails={productInfoSelector}
                                        type="BUNDLE"
                                        featureFlags={featureFlags}
                                    />
                                </ErrorBoundary>
                            </div>
                        </section>
                    )}

                    <ErrorBoundary>
                        <BelowTheFold>
                            {bundleRecSlots.length > 0 ? (
                                <section className={cx('certona-row')}>
                                    {bundleRecSlots.map(slot => (
                                        <RecommendationSwitch key={slot.slotId} strategy={slot.slotId} pageType="PDP" itemId={ppId} />
                                    ))}
                                </section>
                            ) : null}
                        </BelowTheFold>
                    </ErrorBoundary>
                </section>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    productDetails: state.productDetails,
    preferences: selectPreferences(state),
    settings: state.settings,
    isNative: state.context ? state.context.isNative : false,
    deviceType: state.context ? state.context.deviceType : {},
    featureFlags: state.context ? state.context.featureFlags : {},
    pricingDetails: productPricingSelector(state).calcBundleLevelPrice,
    productInfoSelector: BundleProductInfoSelector(state),
    isPromotional: isPromotionalBundle(state),
    analytics: state.Analytics,
    isSameCoupons: isSameProductsCoupons(state),
    allItemsHaveCoupons: isAllItemsHaveCoupons(state),
    isFpacForBundle: isFpacForBundleSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            onPageReady,
            pageLoadReadyScuccess,
            /* checking inventoryProductOOS */
            pageLoadProductOOS,
        },
        dispatch
    ),
});

export default compose(
    withReducerSaga(
        [
            BundleInventoryReducer,
            BundleItemOfferingReducer,
            BundleNetPriceReducer,
            BundleQuantityReducer,
            BundleProtectionPlanReducer,

            BundleQuantityModalReducer,
            CouponDetailsReducer,
        ],
        [BundleInventorySaga, BundleItemOfferingSaga, BundleNetPriceSaga]
    ),
    connect(mapStateToProps, mapDispatchToProps)
)(BundlePage);
